module.exports = __webpack_public_path__ + "img/down-grey-long-arrow.67dc8359.svg";